import { makeStyles, Typography, Button, Box } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import GroupIcon from '@material-ui/icons/Group';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  icon: {
    fontSize: 48,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  description: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
}));

export type EmptyStateType = 'no-groups' | 'no-links' | 'all-hidden';

interface EmptyStateProps {
  type: EmptyStateType;
  linkType?: 'onboarding' | 'team';
  onAddClick?: () => void;
}

const messages: Record<
  EmptyStateType,
  { title: string; description: (linkType?: string) => string }
> = {
  'no-groups': {
    title: 'No Groups Found',
    description: () =>
      'Join groups to see onboarding links and team documentation.',
  },
  'no-links': {
    title: 'No Links Yet',
    description: linkType =>
      `No ${linkType || 'onboarding'} links for your groups yet. Be the first to add one!`,
  },
  'all-hidden': {
    title: 'All Content Hidden',
    description: () =>
      "You've hidden all sections. Use settings to restore them.",
  },
};

export const EmptyState = ({ type, linkType, onAddClick }: EmptyStateProps) => {
  const classes = useStyles();
  const message = messages[type];

  return (
    <Box className={classes.root}>
      {type === 'no-groups' ? (
        <GroupIcon className={classes.icon} />
      ) : (
        <AddIcon className={classes.icon} />
      )}
      <Typography variant="h6" className={classes.title}>
        {message.title}
      </Typography>
      <Typography variant="body2" className={classes.description}>
        {message.description(linkType)}
      </Typography>
      {type === 'no-links' && onAddClick && (
        <Button
          variant="outlined"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onAddClick}
        >
          Add First Link
        </Button>
      )}
    </Box>
  );
};
